import React from "react";
import { ITransactionDetails, TransactionDetailsProps, TransactionDetailsState } from "../Interface";
import './TransactionDetails.css';
import DataGrid from "../../../Component/DataGrid/DataGrid";
import { TableColumn } from "react-data-table-component";
import { amountFormat } from "../../../Component/helper";
import CustomMaterialMenu from "../../../Component/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu";
import RefundDialogPopop from "../RefundDialog/RefundDialogPopop";
import TransactionService from "../../../Services/TransactionService";
import { ShowAlert } from "../../../Component/ShowAlert";
import { SyncContext, SyncContextType } from "../../../Contexts/BatchSyncContext";
import { Button, Tooltip } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';

class TransactionDetails extends React.Component<TransactionDetailsProps, TransactionDetailsState> {
    static contextType = SyncContext;
    context!: SyncContextType;
    private tableColumns: TableColumn<ITransactionDetails>[] = [
        {
            name: 'Account Name',
            selector: row => row.account_name,
            sortable: false,
            id: "account_name",

        },
        {
            name: 'Account Number',
            selector: row => row.account,
            sortable: false,
            id: "account",

        },
        {
            name: 'Biller Name',
            selector: row => row.biller_name,
            sortable: false,
            id: "biller_name",
            width: "180px",
            wrap: true
        },
        {
            name: 'Channel',
            selector: row => row.channel,
            sortable: false,
            id: "channel",
            center: true
        },
        {
            name: 'Pool Name',
            selector: row => row.poolNames,
            sortable: false,
            id: "poolNames",
            wrap: true,
        },
        {
            name: 'Payout Partner',
            selector: row => row.payoutParnter,
            sortable: false,
            id: "payoutParnter",
        },
        {
            name: 'Sender Currency',
            selector: row => row.sender_currency,
            sortable: false,
            id: "sender_currency",
            center: true
        },
        {
            name: 'Sender Amount',
            selector: row => amountFormat(row.sender_amount, 'en-US', 'USD'),
            sortable: false,
            id: "sender_amount",
            center: true
        },
        {
            name: 'Paid Amount',
            selector: row => amountFormat(row.paid_amount, 'en-US', 'USD'),
            sortable: false,
            id: "paid_amount"
        },
        {
            name: 'Destination Currency',
            selector: row => row.destination_currency,
            sortable: false,
            id: "destination_currency",
            center: true
        },
        {
            name: 'Destination Amount',
            selector: row => amountFormat(row.destination_amount, `en-${row.destination_currency.substring(0, 2)}`, row.destination_currency),
            sortable: false,
            id: "destination_amount",
            right: true
        },
        {
            name: 'Response Code',
            selector: row => row.response_code,
            sortable: false,
            id: "responsecode",
            center: true
        },
        {
            name: 'Response Message',
            selector: row => row.response_message,
            sortable: false,
            id: "destinationcurrency",
            center: true
        },
        {
            name: 'Uniwallet Transaction Id',
            selector: row => row.uniwallet_transactionId,
            sortable: false,
            id: "uniwallettransactionId",
            center: true
        },
        {
            name: 'Status',
            selector: row => row.transaction_status,
            sortable: false,
            id: "transaction_status",
            center: true
        },
        {
            name: "Actions",
            cell: (row) => {
                const { isRefundVisible } = this.props.transactionLogs

                if (!isRefundVisible) return null;
                return (
                    <CustomMaterialMenu
                        fontSize="small"
                        multiPopoverItems={
                            row.transaction_status === "failed"
                                ? [
                                    { key: "refundToWallet", label: "Refund to wallet" },
                                    { key: "refundToCard", label: "Refund to card" },
                                ]
                                : [{ key: "refundToWallet", label: "Refund to wallet" }]
                        }
                        onPopoverClick={(key_) => {
                            this.setState({
                                popupState: true,
                                selectedRow: row,
                                refundMode: key_,
                            });
                        }}
                        disabled={
                            row.transaction_status === "refunded" ||
                            row.transaction_status === "processing"
                        }
                    />
                );
            },
            allowOverflow: true,
            button: true,
            width: "56px",
        }
    ]

    constructor(props_: TransactionDetailsProps) {
        super(props_);

        this.state = {
            popupState: false,
            selectedRow: null,
            refundMode: '',
            eleTriggerColumnsMenu: null
        }
    }

    public render() {

        return (
            <div className="details-container">
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <h1 style={{ flexGrow: 1 }}>Transaction Details:</h1>
                    <span>Sender's Email Id:&nbsp;</span>
                    <b>{this.props.details.sender_email}</b>
                    <span style={{ width: "50px" }}></span>
                    <span>Sender's Mobile:&nbsp;</span>
                    <b>{this.props.details.sender_mobile}</b>
                    <Tooltip title="Show/hide Columns" arrow>
                        <Button
                            color="primary"
                            onClick={this.showColumnsMenu.bind(this)}
                        >
                            <ViewColumnIcon color="secondary" fontSize="large" />
                        </Button>
                    </Tooltip>
                </div>
                <DataGrid
                    gridId='TransLogsSubGrid'
                    columns={this.tableColumns}
                    data={this.props.details.transaction_details}
                    expandableRows={false}
                    pagination={false}
                    useExternalTriggerForColumsMenu={true}
                    eleTriggerColumnsMenuExternal={this.state.eleTriggerColumnsMenu}
                    onCloseColumnsMenuExternal={this.closeColumnsMenu.bind(this)}
                />
                <RefundDialogPopop
                    open={this.state.popupState}
                    onClose={(state: boolean, selectedAmount: number, action: string) => {
                        if (action == "ok") {
                            this.initiateRefund(state, selectedAmount);
                        }
                        else {
                            this.setState({
                                popupState: state,
                                selectedRow: null
                            });
                        }
                    }}
                    paidAmount={this.state.selectedRow ? (this.state.selectedRow.transaction_status == "failed" ? this.state.selectedRow.paid_amount : this.state.selectedRow.sender_amount) : 0}
                />
            </div>
        )
    }

    //show columns menu
    public showColumnsMenu(event: React.MouseEvent<HTMLElement>) {
        this.setState({
            eleTriggerColumnsMenu: event.currentTarget
        });
    }


    //show columns menu
    public closeColumnsMenu() {
        this.setState({
            eleTriggerColumnsMenu: null
        });
    }

    private async initiateRefund(state: boolean, amount: number) {
        let postdata: any = {
            "transtactionId": this.state.selectedRow ? this.state.selectedRow.transaction_id : "",
            "amount": amount.toString(),
            "refundType": this.state.refundMode.indexOf("wallet") ? "wallet" : "source"
        }

        let tr = await TransactionService.initiatetransaction(this.props.accessToken, postdata);

        if (tr.ok) {
            this.setState({
                popupState: state,
                selectedRow: null
            }, () => {
                ShowAlert("PassportPay", "The refund request has been successfully processed.", 'success').then(() => {
                    if (this.props.onRefundDone) {
                        this.props.onRefundDone(true);
                    }
                })
            });
        }
        else {
            this.setState({
                popupState: state,
                selectedRow: null
            }, () => {
                tr.json().then(resp => {
                    ShowAlert("PassportPay", `${JSON.parse(resp)}`, 'error')
                });
            });

        }

        /*TransactionService.initiatetransaction(this.props.accessToken, postdata).then(tr => {
            if (tr.ok) {
                this.setState({
                    popupState: state,
                    selectedRow: null
                }, () => {
                    ShowAlert("PassportPay", "The refund request has been successfully processed.", 'success')
                });
            }
            else {
                tr.json().then(resp => {
                    this.setState({
                        popupState: state,
                        selectedRow: null
                    }, () => {
                        ShowAlert("PassportPay", `${resp}`, 'error')
                    });
                });
            }
        });*/
    }
}

export default TransactionDetails;